const map = {
	"./8/Spectate/RegulationLogosSection.layout.js": [
		50019,
		[
			6932
		]
	],
	"./96/Spectate/RegulationLogosSection.layout.js": [
		87218,
		[
			4889
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 93861;
module.exports = webpackAsyncContext;